import request from '@/utils/request'

import { Device, Driver } from '@/types/device'

export function Create(device: Device): Promise<Device> {
  return request.post('/device', device)
}

export function Find(): Promise<Device[]> {
  return request.get('/device')
}

export function Patch(id: number, device: Device): Promise<Device[]> {
  return request.patch(`/device/${id}`, device)
}

export function FindDriver(): Promise<Driver[]> {
  return request.get('/device/driver')
}

export function GetById(id: number): Promise<Device> {
  return request.get(`/device/${id}`)
}

export function CreateGroup(name: string): Promise<Device> {
  return request.post('/device/group', { name, isGroup: true })
}

export function Delete(id: number): Promise<Device> {
  return request.delete(`/device/${id}`)
}

export type Action = string
export const ACTCONNET: Action = 'connect'
export const ACTDISCONNECT: Action = 'disconnect'
export const ACTRESTART: Action = 'restart'

/**
 *
 * @param id ID dari device yang akan diperintah
 * @param action Perintah yang harus dieksekusi oleh driver (connect, disconnect, restart)
 */
export function Put(id: number, action: Action): Promise<Device> {
  return request.put(`/device/${action}/${id}`)
}
